export { DefsLinearGradient } from './DefsLinearGradient'
